export { DefsLinearGradient } from './DefsLinearGradient'
